import { StyleSheet } from 'react-native';
import { fontFamily } from '../../../constants/palette';

export default StyleSheet.create({
  imageStyle: {
    padding: 10,
    margin: 10,
    height: 25,
    width: 20,
    resizeMode: 'stretch',
    alignItems: 'center',
  },
});
